const UNAVAILABLE = 'Indisponível';

export const UNAVAILABLE_MESSAGE =
  'Avaliação indisponível! Quantidade de tentativas excedidas';

export const NO_QUESTIONS_MESSAGE =
  'Esta avaliação ainda não possui questões disponíveis. Tente novamente mais tarde.';

export function isAssessmentUnavailable(data) {
  return Boolean(data) && data.availabitity === UNAVAILABLE;
}

export function hasQuestionsToStart(data) {
  return Boolean(data) && data.questionCount > 0;
}
